// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YL3Q5HIK37Pfr-SwsX2jD","cancelBtn":"_2etEeR5DHGMrouBBtFIiFU","icon":"_1GWDJ14JF_O1ang8TrSbpp","saveBtn":"_3RJdYvzVMvWhWA_GqS1nlI"};